import useProject from '@hooks/useProject';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

function GoogleLoginProvider({ children }:Props) {
    const project = useProject();
    return (
        <GoogleOAuthProvider clientId={project?.googleClientId || clientId}>
            {children}
        </GoogleOAuthProvider>
    );
}

export default GoogleLoginProvider;
